<div
  *ngIf="scheduledOrder && scheduledOrder.ValidationResult"
  class="validation-checks-container"
>
  <!-- Last Processing Cycle Section (conditionally shown) -->
  <div
    *ngIf="showLastProcessingCycle && scheduledOrder.LastProcessingCycle"
    class="last-cycle-section"
  >
    <!-- Processing Cycle Card -->
    <div class="cycle-card">
      <!-- Card Header -->
      <div class="cycle-card-header">
        <div class="cycle-header-left">
          <i class="pi pi-history cycle-header-icon"></i>
          <h4 class="cycle-section-title">Last Processing Cycle</h4>
        </div>
        <p-tag
          *ngIf="scheduledOrder.LastProcessingCycle.Status === 'Failed'"
          value="Failed"
          severity="danger"
          [rounded]="true"
        />
        <p-tag
          *ngIf="scheduledOrder.LastProcessingCycle.Status === 'Success'"
          value="Success"
          severity="success"
          [rounded]="true"
        />
        <p-tag
          *ngIf="scheduledOrder.LastProcessingCycle.Status === 'Void'"
          value="Void"
          severity="warning"
          [rounded]="true"
        />
        <p-tag
          *ngIf="scheduledOrder.LastProcessingCycle.Status === 'Queued'"
          value="Queued"
          severity="info"
          [rounded]="true"
        />
      </div>

      <!-- Card Divider -->
      <div class="cycle-card-divider"></div>

      <!-- Info Items Container (side-by-side on desktop) -->
      <div class="cycle-info-items">
        <!-- Processing ID Section -->
        <div class="cycle-info-item">
          <div class="info-icon-wrapper">
            <i class="pi pi-hashtag"></i>
          </div>
          <div class="info-content">
            <span class="info-label">Processing ID</span>
            <span class="info-value">{{
              scheduledOrder.LastProcessingCycle.ProcessingId
            }}</span>
          </div>
        </div>

        <!-- Last Occurrence Section -->
        <div
          *ngIf="
            scheduledOrder.LastProcessingCycle.Status !== 'Processing' &&
            scheduledOrder.LastOccurrenceUtc
          "
          class="cycle-info-item"
        >
          <div class="info-icon-wrapper">
            <i class="pi pi-clock"></i>
          </div>
          <div class="info-content">
            <span class="info-label">Last Occurrence</span>
            <span class="info-value">{{
              scheduledOrder.LastOccurrenceUtc | date: "MMM d, y, h:mm a"
            }}</span>
          </div>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="cycle-actions">
        <p-button
          severity="secondary"
          label="Cycle Details"
          icon="pi pi-file-edit"
          (onClick)="onViewCycleDetails()"
          styleClass="cycle-action-btn"
          [outlined]="true"
        />
        <p-button
          severity="secondary"
          label="Processing Logs"
          icon="pi pi-list"
          (onClick)="onViewProcessingLogs()"
          styleClass="cycle-action-btn"
          [outlined]="true"
        />
      </div>
    </div>

    <p-divider styleClass="cycle-divider" />
  </div>

  <!-- Header Section -->
  <div class="checks-header">
    <div class="header-left">
      <div class="header-icon">
        <i
          class="pi"
          [ngClass]="{
            'pi-check-circle': allChecksPassed,
            'pi-exclamation-triangle': failedChecks > 0 || warningChecks > 0,
          }"
        ></i>
      </div>
      <div class="header-text">
        <h3 class="header-title">Validation Checks</h3>
        <p class="header-subtitle">
          Review validation status for this scheduled order
        </p>
      </div>
    </div>
    <div class="header-right">
      <!-- Status Summary Tags -->
      <div class="status-summary">
        <p-tag
          *ngIf="allChecksPassed"
          severity="success"
          [value]="passedChecks + '/' + totalChecks + ' Passed'"
          icon="pi pi-check"
        />
        <p-tag
          *ngIf="failedChecks > 0"
          severity="danger"
          [value]="failedChecks + ' Failed'"
          icon="pi pi-times"
        />
        <p-tag
          *ngIf="warningChecks > 0"
          severity="warn"
          [value]="warningChecks + ' Warning'"
          icon="pi pi-exclamation-triangle"
        />
      </div>
    </div>
  </div>

  <!-- Checks List -->
  <div class="checks-list">
    <div
      *ngFor="let item of validationCheckItems; let i = index; let last = last"
      class="check-item-wrapper"
    >
      <div
        class="check-item"
        [class.check-success]="
          !item.isCheckFailed && !item.isCheckSkipped && !item.isCheckWarning
        "
        [class.check-failed]="item.isCheckFailed"
        [class.check-warning]="item.isCheckWarning"
        [class.check-skipped]="item.isCheckSkipped"
        [class.clickable]="item.isCheckShippingRateWarning"
        (click)="
          item.isCheckShippingRateWarning &&
            openShippingRatesCalculationErrorsPopup()
        "
        [pTooltip]="
          item.isCheckShippingRateWarning
            ? 'One or more Shipping Rates failed to calculate. Click to view details.'
            : ''
        "
        tooltipPosition="top"
      >
        <!-- Status Icon with Background Circle -->
        <div class="check-icon-wrapper">
          <div
            class="check-icon"
            [ngClass]="{
              'icon-success':
                !item.isCheckFailed &&
                !item.isCheckWarning &&
                !item.isCheckSkipped,
              'icon-failed': item.isCheckFailed,
              'icon-warning': item.isCheckWarning,
              'icon-skipped': item.isCheckSkipped,
            }"
          >
            <i
              class="pi"
              [ngClass]="{
                'pi-check':
                  !item.isCheckFailed &&
                  !item.isCheckWarning &&
                  !item.isCheckSkipped,
                'pi-times': item.isCheckFailed,
                'pi-exclamation-triangle': item.isCheckWarning,
                'pi-minus': item.isCheckSkipped,
              }"
            ></i>
          </div>
        </div>

        <!-- Check Content -->
        <div class="check-content">
          <div class="check-main">
            <span class="check-text">
              {{ item.isCheckFailed ? item.errorText : item.successText }}
            </span>
            <!-- Additional Error Text -->
            <span
              *ngIf="item.additionalErrorText && item.isCheckFailed"
              class="additional-error-text"
            >
              {{ item.additionalErrorText }}
            </span>
          </div>
          <!-- Error Code Badge -->
          <a
            *ngIf="item.isCheckFailed && !item.isCheckSkipped"
            class="error-code-badge"
            href="https://support.autoship.cloud/article/543-scheduled-order-processing-errors"
            target="_blank"
            rel="noopener noreferrer"
            (click)="$event.stopPropagation()"
            [pTooltip]="'Click to view error code documentation'"
            tooltipPosition="top"
          >
            <i class="pi pi-info-circle"></i>
            <span>{{ item.processingErrorCode }}</span>
          </a>
        </div>
      </div>

      <!-- Divider between items (except last) -->
      <p-divider *ngIf="!last" styleClass="check-divider" />
    </div>
  </div>
</div>
